import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/fund/importer/fundImporterActions';

export default importerReducers(actions);
